<template>
  <b-modal id="marei-mekomos" size="lg" :title="modalTitle" :lazy="true">
    <div :class="isRTL ? 'rtl' : ''">
      <div>
        <a
          :href="'/mm/pdf/'+mareiMekomos.shiurim.id"
          @click="trackDownload"
          class="btn btn-primary w-100"
        >{{ $_t('KW:downloadPdf') }}</a>
        <div class="text-right text-rtl w-100 mt-3" v-html="mareiMekomos.note"></div>
      </div>
      <div slot="modal-footer" class="w-100">
        <a
          :href="'/mm/pdf/'+mareiMekomos.shiurim.id"
          class="btn btn-primary w-100"
        >{{ $_t('KW:downloadPdf') }}</a>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  data: function () {
    return {
      mareiMekomos: {
        note: null,
        masechta: null,
        shiurim: {
          daf: null,
          message: null,
        },
        magidShiur: {
          name: null,
        },
      },
    };
  },
  created: function () {
    var _this = this;
    this.$root.$on("show_mm_modal", function (value) {
      _this.mareiMekomos = value;
    });
  },
  computed: {
    modalTitle: function () {
      return (
        this.mareiMekomos.masechta +
        " " +
        this.mareiMekomos.shiurim.daf +
        " " +
        this.mareiMekomos.shiurim.message +
        " by " +
        this.mareiMekomos.magidShiur.name
      );
    },
  },
  methods: {
    trackDownload: function () {
      ga("send", "event", "Marei Mekomos", "Download", this.modalTitle);
    },
  },
};
</script>
